<template>
  <el-row
    class="pre-wrap"
    v-loading.fullscreen.lock="fullscreenLoading"
  >
    <h3>
      {{ $t('preCheckIn.insuranceCard.title') }}
    </h3>
    <div
      class="upload-insurance insurance-card pre-reg"
    >
      <AccordionField
        class="ins-block primary active"
        insurance-type="Primary"
        :insurance.sync="primaryInsurance"
        :active="true"
        :is-open="true"
        :content="setInsuranceDescription('primary')"
        :first="primaryTitle.toLowerCase()"
        ref="primaryInsuranceBlock"
        :show="insurancesLoaded"
        @updateData="updateActiveData"
        @renderData="forceRerender"
        @nextStep="nextStep"
      />
      <AccordionField
        :class="[{'active': isPrimary}, 'ins-block', 'secondary']"
        insurance-type="Secondary"
        :insurance="secondaryInsurance"
        :active="isPrimary"
        :primary-button="true"
        :content="setInsuranceDescription('secondary')"
        :first="primaryTitle.toLowerCase()"
        ref="secondaryInsuranceBlock"
        :show="insurancesLoaded"
        @updateData="updateActiveData"
        @renderData="forceRerender"
      />
      <AccordionField
        :class="[{'active': isSecondary}, 'ins-block', 'tertiary']"
        insurance-type="Tertiary"
        :insurance="tertiaryInsurance"
        :active="isSecondary"
        :primary-button="true"
        :secondary-button="true"
        :content="setInsuranceDescription('tertiary')"
        :first="secondaryTitle.toLowerCase()"
        ref="tertiaryInsuranceBlock"
        :show="insurancesLoaded"
        @updateData="updateActiveData"
        @renderData="forceRerender"
      />
      <el-row class="submit-container">
        <el-row class="submit-btn">
          <el-button
            type="primary"
            @click="submitData()"
          >
            {{ $t('common.buttons.next') }}
          </el-button>
        </el-row>
      </el-row>
    </div>
  </el-row>
</template>

<script>
import store from "../../store";
import AccordionField from "../components/form/AccordionField";

export default {
  name: 'InsuranceCard',
  components: {
    AccordionField
  },
  data: () => {
    return {
      insurances: [],
      fullscreenLoading: false,
      patientInsurances: {},
      patientNumber: null,
      activeStep: null,
      routerName: 'ContactInfo',
      primaryTitle: '',
      secondaryTitle: '',
      tertiaryTitle: '',
      isPrimary: false,
      isSecondary: false,
      isTertiary: false,
      primaryInsurance: {},
      secondaryInsurance: {},
      tertiaryInsurance: {},
      insurancesLoaded: false,
      sid: null,
      coverageOrders: [
        { name: 'primary', index: 1},
        { name: 'secondary', index: 2},
        { name: 'tertiary', index: 3}
      ],
    };
  },
  created () {
    this.fullscreenLoading = true;
    this.setProgressBar();
    this.setInsuranceTitles();
    this.activeStep = this.$route.path.substring(1).split('/')[1];
    this.sid = this.getSessionId();
    this.getDataByPatientNumber().then(() => {
      this.patientNumber = store.getters.patientData.patientNumber;
      this.saveStatisticData(this.sid, {
        active_step: this.activeStep,
        render_InsuranceCard : 'true'
      });
      this.getAllInsurances();
    }).catch(() => {
      this.fullscreenLoading = false;
      this.setMessage(this.$t('common.errors.fail'));
    });
  },
  methods: {
    setInsuranceTitles() {
      this.coverageOrders.forEach((item) => {
        this[item.name + 'Title'] = this.$t('preCheckIn.insuranceCard.types.' + item.name);
      });
    },
    setInsuranceDescription(type = null) {
      let insuranceData = {
        primary: this.$t('preCheckIn.insuranceCard.description.primary'),
        secondary: this.$t('preCheckIn.insuranceCard.description.secondary'),
        tertiary: this.$t('preCheckIn.insuranceCard.description.tertiary')
      };
      if (!type) return '';
      return insuranceData[type];
    },
    async forceRerender(args) {
      this.fullscreenLoading = true;
      args.forEach((item) => {
        let name = item + 'Insurance';
        this.$set(this, name, store.getters.insurancesData[name]);
      });
      this.fullscreenLoading = false;
    },
    updateActiveData(type) {
      this['is' + this.capitalized(type)] = true;
    },
    submitData () {
      this.fullscreenLoading = true;
      this.saveStatisticData(this.sid, {
        submit_InsuranceCard: 'true'
      });
      let primaryBlock = this.$el.querySelector('.ins-block.primary form');
      if (primaryBlock.length) {
        this.$refs[primaryBlock.dataset.blockname].$refs.InsuranceBlock.validate();
        this.fullscreenLoading = false;
      } else {
        this.setMessage(this.$t('common.errors.fail'));
        this.fullscreenLoading = false;
      }
    },
    nextStep(){
      this.fullscreenLoading = true;
      return this.updateStepsData(store.getters.patientData.patientId, {[this.activeStep] : 1}).then((response) => {
        if (response.data.isSuccess) {
          this.$router.push({
            name: this.routerName,
            params: {
              patientNumber: this.patientNumber
            },
          });
        } else {
          this.fullscreenLoading = false;
          this.setMessage(this.$t('common.errors.update', { type: this.$t('preCheckIn.insuranceCard.title').toLowerCase() }), 'warning');
        }
      });
    },
    updateUserData(appData) {
      return this.$axios.post(process.env.VUE_APP_INTERNAL_API + '/api/updateUserAppData', {
        pid: store.getters.patientData.patientId,
        fields: appData
      });
    },
    getInsuranceImages (insurance = {}) {
      return this.$axios('/Insurance/GetInsuranceImages', {
        method: 'GET',
        params: {
          patientNumber: store.getters.patientData.patientNumber,
          planId: insurance.planId,
          policyNumber: insurance.policyNumber
        }
      });
    },
    getPatientInsurance() {
      return this.$axios('/Insurance/GetPatientInsurances', {
        method: 'GET',
        params: {
          patientNumber: this.patientNumber
        }
      }).then((response) => {
        if (response.data.isSuccess) {
          const promises = [];
          let count = 0;
          this.coverageOrders.forEach((item) => {
            let name = item.name + 'Insurance',
                show = 'is' + this.capitalized(item.name);
            let insuranceParams = response.data.data.filter((insurance) => insurance.isActive && insurance.coverageOrder == item.index).shift();
            this.$refs[name + 'Block'].setInsurances(this.insurances);
            if (typeof insuranceParams !== 'undefined') this[name] = insuranceParams;

            if (!this.isObjEmpty(this[name])) {
              this.insurances.map((item) => {
                if (item.code == this[name].planCode) this.$set(this[name], 'name', item.name);
              });
              promises.push(
                new Promise((resolve) => {
                  this.getInsuranceImages(this[name]).then((response) => {
                    if (response.data.isSuccess) {
                      const frontSide = response.data.data.filter((el) => {return el.imageDataString.length && el.isFrontImage;});
                      const backSide = response.data.data.filter((el) => {return el.imageDataString.length && !el.isFrontImage;});

                      if (!frontSide.length && !backSide.length) {
                        this.$set(this, name, {
                          frontSide: '',
                          backSide: ''
                        });
                      } else {
                        this.$set(this[name], 'frontSide', 'data:image/png;base64,' + frontSide[0].imageDataString);
                        this.$set(this[name], 'backSide', 'data:image/png;base64,' + backSide[0].imageDataString);
                        this.$set(this, show, true);
                        this.saveStatisticData(this.sid, {
                          [name + '_loaded']: 'true'
                        });
                      }
                    } else {
                      this.$set(this, name, {
                        frontSide: '',
                        backSide: ''
                      });
                    }
                    count++
                    resolve(this[name]);
                    store.dispatch('setInsurancesData', {type: name, params: this[name]});
                    this.$set(this.patientInsurances, name, this[name]);
                  }).catch(() => {
                    this.setMessage(this.$t('common.errors.fail'));
                  });
                })
              );
              Promise.all(promises).then(() => {
                this.insurancesLoaded = true;
                this.$refs.primaryInsuranceBlock.isOpen = true;
                this.fullscreenLoading = false;
              });
            } else {
              this.$set(this, name, {
                frontSide: '',
                backSide: ''
              });
              count++
              store.dispatch('setInsurancesData', {type: name, params: this[name]});
              this.$set(this.patientInsurances, name, this[name]);
              this.insurancesLoaded = true;
              this.$refs.primaryInsuranceBlock.isOpen = true;

              if (count == 3) this.fullscreenLoading = false;
            }
          });
        } else {
          this.fullscreenLoading = false;
          this.setMessage(this.$t('common.errors.get', { type: this.$t('preCheckIn.insuranceCard.title').toLowerCase() }));
        }
        this.updateUserAppData(store.getters.patientData.patientId, {
          active_pr_step: this.activeStep,
          active_route: this.$route.name
        });
      }).catch(() => {
        this.fullscreenLoading = false;
        this.setMessage(this.$t('common.errors.fail'));
      });
    },
    getAllInsurances() {
      this.$axios.post(process.env.VUE_APP_INTERNAL_API + '/api/getAllInsurances').then((response) => {
        if (response.data.insurances) {
          this.insurances = response.data.insurances;
          this.getPatientInsurance();
        } else {
          this.fullscreenLoading = false;
          this.setMessage(this.$t('common.errors.get', { type: this.$t('preCheckIn.insuranceCard.list') }), 'warning');
        }
      })
    },
  }
};
</script>
